module.exports = __webpack_public_path__ + "img/bulleted-list.88e0ac69.svg";